// Mirrors NotificationTemplate.TRIGGER_SOURCE_CHOICES in
// backend/notification/models.py -- dev-managed choices, kept in sync by hand.
export const TRIGGER_SOURCE_OPTIONS: { value: string; label: string }[] = [
  { value: "booking.booking", label: "Booking" },
  { value: "booking.bookingquoterequest", label: "Booking Quote Request" },
  { value: "stream.stream", label: "Stream" },
  { value: "venue.venue", label: "Venue" },
  { value: "checklist.checklist", label: "Checklist" },
  { value: "checklist.crew_assignment", label: "Crew Assignment" },
  { value: "task.task", label: "Task" },
  { value: "client_portal.website", label: "Client Portal" },
  { value: "system.manual", label: "Manual Notification" },
  { value: "system.automated", label: "Automated Notification" },
  { value: "referral_program.referralprogram", label: "Referral Program" },
  { value: "job_career.application_submitted", label: "Job Application Submitted" },
  { value: "job_career.application_status_changed", label: "Job Application Status Changed" },
];
